import React, { useEffect, useState } from "react";
import { StackScreen } from "@life-line-lab/components-react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import DriverCreateForm from "Components/new-driver-management/driver-create-form";
import { useHistory, useParams } from "react-router-dom";
import { fetchDriver, updateDriver } from "Services/new-driver-management.services";
import { decode, toaster } from "Helpers/index";
import { DriverCategoriesTabs } from "Types/new_driver_types";
import { useAccessControlList, useSession } from "Hooks/index";

const DriverUpdate = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const { id } = useParams<{ id: string }>();
  const { formType } = useParams<{ formType: DriverCategoriesTabs }>() || "";
  const driverID = decode(id) || "";

  const { roleTypes } = useSession();

  const permission = useAccessControlList({
    roleTypes: roleTypes,
    resource: "Rider_Management",
  });

  // permissions
  const canUpdate = permission.rights.includes("UPDATE");

  const [driverDetails, setDriverDetails] = useState<any>();
  const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false);

  useEffect(() => {
    if (driverID) {
      handleFetchDriverDetails();
    }
  }, [driverID]);

  const onBack = () => {
    history.goBack();
  };

  const handleFetchDriverDetails = async () => {
    const responseData = await fetchDriver(driverID);

    if (responseData && !responseData.error) {
      setDriverDetails(responseData);
    } else {
      toaster("error", responseData.error.message);
    }
  };

  const handleUpdateDriver = async (data) => {
    setIsSubmitLoading(true);

    const responseData = await updateDriver(data);

    if (responseData && !responseData.error) {
      setTimeout(() => {
        toaster("success", t("toaster.driverInfoUpdated"));
        setIsSubmitLoading(false);
        onBack();
      }, 3000);
    } else {
      if (typeof responseData.error.message === "string") {
        toaster("error", responseData.error.message);
      } else {
        toaster("error", responseData.error.message.message.replace('"', ""));
      }

      setIsSubmitLoading(false);
    }
  };

  const handleCloseStackScreen = () => {
    history.push("/driver-management/driver");
  };

  return (
    canUpdate && (
      <div className="driver-management driver-profile-page">
        <Helmet>
          <title>{t("pageTitle.editDriverProfile")}</title>
        </Helmet>
        <StackScreen
          title={
            <div>
              <img alt={t("alt.logo")} src="/assets/images/banner_logo.png" height={30} />
            </div>
          }
          isOpen={true}
          renderHeader={<div></div>}
          onClose={() => !isSubmitLoading && handleCloseStackScreen()}
        >
          <DriverCreateForm
            onBack={onBack}
            onSubmitEdit={handleUpdateDriver}
            driverDetails={driverDetails}
            formType={formType}
            isSubmitLoading={isSubmitLoading}
          />
        </StackScreen>
      </div>
    )
  );
};

export default DriverUpdate;
